import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { tasksAPI, projectsAPI, employeesAPI } from '../../lib/api';

const Tasks = () => {
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [tasksRes, projectsRes, employeesRes] = await Promise.all([
        tasksAPI.getAll(),
        projectsAPI.getAll(),
        employeesAPI.getAll()
      ]);
      setTasks(tasksRes.data);
      setProjects(projectsRes.data);
      setEmployees(employeesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getProjectName = (projectId) => {
    const project = projects.find(p => p.id === projectId);
    return project?.name || '-';
  };

  const getEmployeeName = (employeeId) => {
    const employee = employees.find(e => e.id === employeeId);
    return employee?.name || '-';
  };

  const columns = [
    { key: 'title', label: 'Task' },
    { key: 'project_id', label: 'Project', render: (val) => getProjectName(val) },
    { key: 'assigned_to', label: 'Assigned To', render: (val) => getEmployeeName(val) },
    { key: 'due_date', label: 'Due Date', type: 'date' },
    { key: 'priority', label: 'Priority', type: 'status' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'title', label: 'Task Title', required: true, placeholder: 'Enter task title' },
    {
      name: 'project_id',
      label: 'Project',
      type: 'select',
      options: projects.map(p => ({ value: p.id, label: p.name })),
    },
    {
      name: 'assigned_to',
      label: 'Assigned To',
      type: 'select',
      options: employees.map(e => ({ value: e.id, label: e.name })),
    },
    { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Task description' },
    { name: 'due_date', label: 'Due Date', type: 'date' },
    {
      name: 'priority',
      label: 'Priority',
      type: 'select',
      defaultValue: 'medium',
      options: [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
      ],
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'todo',
      options: [
        { value: 'todo', label: 'To Do' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await tasksAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await tasksAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await tasksAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Tasks"
      description="Manage project tasks"
      data={tasks}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
      searchField="title"
    />
  );
};

export default Tasks;
